import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { LogoBig } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-4">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 text-center shadow-sm ring-1 ring-ink/5 sm:p-10" data-testid="payment-cancel">
        <div className="mb-6 flex justify-center">
          <LogoBig />
        </div>
        <XCircle className="mx-auto mb-4 h-14 w-14 text-terra" />
        <h1 className="font-serif text-2xl font-semibold text-ink">Paiement interrompu</h1>
        <p className="mt-3 text-ink/65">
          Aucun montant n'a été débité et votre réservation n'a pas été enregistrée. Vous pouvez recommencer quand
          vous voulez, ou appeler Angélique au 06 73 31 82 36 pour réserver par téléphone.
        </p>
        <Link
          to="/#reserver"
          data-testid="retry-booking-link"
          className="mt-8 inline-flex min-h-[48px] items-center rounded-full bg-terra px-6 text-sm font-semibold text-white transition-colors hover:bg-terra-dark"
        >
          Recommencer ma réservation
        </Link>
      </div>
    </div>
  );
}
